<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    @active-profile-loaded="active_profile = $event"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0"
  >
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <!-- Table body -->
        <div class="visitor-card shadow border-primary">
          <div class="card-body bg-white pt-2">

           <div class="d-flex align-items-center sticky-top">
              <button
                class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#dashboardSidebarOffcanvas"
                aria-controls="dashboardSidebarOffcanvas"
                aria-label="Open workspace menu"
              >
                <i class="bx bx-menu-alt-left fs-5"></i>
              </button>

              <div class="ms-auto">
                <CreateFeed
                  @trigger_component="trigger_comp"
                  ref="create_feed"
                  @new_report="addNewReport"
                  :activeProfile="active_profile"
                />
              </div>
            </div>
            <div class="row g-2 mb-3">
              <div
                v-for="card in feed_dashboard_cards"
                :key="card.label"
                class="col-6 col-md-4 col-xl"
              >
                <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                  <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                    <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                      <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                      <div class="fw-bold text-dark h4 mb-0 mt-2">{{ card.value }}</div>
                    </div>
                    <span
                      class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0"
                    >
                      <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="is_loading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Feed List...</p>
            </div>
            <div v-show="!is_loading">
              <div class="table-responsive">
                <table
                  id="report-table"
                  class="table table-hover align-middle text-xxs w-100 report-table">
                  <thead class="btn-primary text-white">
                    <tr>
                      <th class="text-nowrap">No</th>
                      <th class="text-center text-nowrap">Creator</th>
                      <th class="text-nowrap">Description</th>
                      <th v-if="can_show_feed_tags" class="text-center text-nowrap">Primary Tag</th>
                      <th v-if="can_show_feed_segments" class="text-center text-nowrap">Segment</th>
                      <th v-if="can_show_feed_portals" class="text-center text-nowrap">Portal</th>
                      <th v-if="can_show_feed_authors" class="text-center text-nowrap">Authors</th>
                      <th v-if="can_show_feed_tags" class="text-center text-nowrap">Tags</th>
                      <th class="text-center text-nowrap">Engagement</th>
                      <th class="text-center text-nowrap">Date</th>
                      <th class="text-center text-nowrap">Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(report, index) in reports"
                      :key="report.id || index"
                    >
                      <th>{{ index + 1 }}</th>

                      <!-- CREATED BY -->
                      <td class="text-center">
                            <div class="fw-bold">
                              <span v-if="report.company">
                                {{ report.company.company_name }}
                              </span>
                              <span v-else-if="report.base_profile?.user">
                                {{ report.base_profile.user.first_name }} {{
                                report.base_profile.user.last_name }}
                              </span>
                            </div>
                            <div class="text-muted">
                              <span v-if="report.company">
                                {{ report.company.email }}
                              </span>
                              <span v-else-if="report.base_profile?.user">
                                {{ report.base_profile.user.email }}
                              </span>
                            </div>
                      </td>

                      <!-- DESCRIPTION -->
                      <td>
                        <span
                          class="description-text"
                          :title="getTextOnly(report.description)"
                        >
                          {{ report.description ?
                          getTextOnly(report.description) : report.name || '-'
                          }}
                        </span>
                      </td>

                      <!-- PRIMARY TAG -->
                      <td v-if="can_show_feed_tags" class="text-center">
                        <span
                          v-if="report.primary_tag"
                          class="badge badge-tag"
                        >
                          {{ report.primary_tag.name }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </td>

                      <!-- SEGMENT -->
                      <td v-if="can_show_feed_segments" class="text-center">
                        <span v-if="report.topic" class="badge badge-light">
                          {{ report.topic.name }}
                        </span>
                        <span v-else class="text-muted">-</span>
                      </td>

                      <!-- PORTAL -->
                      <td v-if="can_show_feed_portals" class="text-center">
                        <span class="badge badge-portal">
                          {{ report.portal.name }}
                        </span>
                      </td>

                      <!-- AUTHORS -->
                      <td v-if="can_show_feed_authors" class="text-center">
                        <div
                          v-if="report.authors && report.authors.length"
                          class="d-flex flex-wrap justify-content-center gap-2"
                        >
                          <span
                            v-for="author in report.authors"
                            :key="author.id"
                            class="badge badge-light"
                          >
                            {{ author.author_name }}
                          </span>
                        </div>
                        <span v-else class="text-muted">-</span>
                      </td>

                      <!-- TAGS -->
                      <td v-if="can_show_feed_tags" class="text-center">
                        <div class="d-flex flex-wrap justify-content-center gap-2">
                          <span
                            v-for="tag in report.tags ? report.tags.slice(0, 1) : []"
                            :key="tag.id"
                            class="badge badge-tag"
                          >
                            {{ tag.name || tag.tag || 'tag' }}
                          </span>

                          <span
                            v-if="report.tags && report.tags.length > 3"
                            class="badge badge-portal border-dashed text-muted"
                          >
                            +{{ report.tags.length - 3 }} more
                          </span>
                        </div>

                        <span
                          v-if="!report.tags || !report.tags.length"
                          class="text-muted"
                        >
                          -
                        </span>
                      </td>

                      <!-- ENGAGEMENT -->
                      <td class="text-center">
                        <div class="d-flex flex-wrap justify-content-center gap-2">
                          <span
                            ><i class="bx bx-like"></i> {{ report.total_likes
                            }}</span
                          >
                          <span
                            ><i class="bx bx-comment"></i> {{
                            report.total_comments }}</span
                          >
                        </div>
                      </td>

                      <!-- DATE -->
                      <td class="text-nowrap text-center">
                        {{ report.publication_date }}
                      </td>

                      <!-- ACTION -->
                      <td class="text-center">
                        <button
                          @click="view_report(report)"
                          class="btn btn-light btn-sm rounded-3 text-success border text-xxs"
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Your Voice -->
              <div
                class="tab-pane fade"
                id="consolidation_loan_info"
                role="tabpanel"
                aria-labelledby="consolidation_loan_tab"
              >
                <!-- Your Voice content -->
              </div>
            </div>
          </div>

          <teleport to="body">
            <div
              class="modal fade"
              id="view_report_modal"
              tabindex="-1"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
              >
                <div class="modal-content" v-if="selected_report">
                  <div class="modal-header bg-light">
                    <div class="d-flex flex-column">
                      <h6 class="modal-title text-primary mb-0">
                        Report Details
                      </h6>
                      <small class="text-xxs text-muted"
                        >Published on: {{ selected_report.publication_date
                        }}</small
                      >
                    </div>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <div class="mb-4">
                      <label
                        class="text-xxs fw-bold text-muted"
                        >Description</label
                      >
                      <div class="p-3 border rounded bg-light mt-1">
                        <div
                          class="text-xs"
                          v-html="selected_report.description"
                        ></div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3 mb-4">
                        <label
                          class="text-xxs fw-bold text-muted"
                          >Creator</label
                        >
                        <div class="d-flex align-items-center mt-2">
                          <div v-if="selected_report.company">
                            <p class="mb-0 fw-bold text-xs">
                              {{ selected_report.company.company_name }}
                            </p>
                            <small class="text-xxs text-muted"
                              >Organisation ({{ selected_report.company.email
                              }})</small
                            >
                          </div>
                          <div
                            v-else-if="selected_report.base_profile && selected_report.base_profile.user"
                          >
                            <p class="mb-0 fw-bold text-xs">
                              {{ selected_report.base_profile.user.first_name }}
                              {{ selected_report.base_profile.user.last_name }}
                            </p>
                            <small class="text-xxs text-muted"
                              >User ({{ selected_report.base_profile.user.email
                              }})</small
                            >
                          </div>
                        </div>
                      </div>

                      <div class="col-md-3 mb-4 border-start-md">
                        <div class="text-xxs fw-bold text-muted">
                          <label>Portal</label>:
                          <span v-if="selected_report.portal.portal_type">
                          {{ selected_report.portal.portal_type.name }}
                          </span>
                        </div>
                       
                        <p class="mb-0 fw-bold text-xs mt-2">
                          {{ selected_report.portal.name }}
                        </p>
                      </div>

                      <div
                        class="col-md-3 mb-4 border-start-md"
                        v-if="selected_report.primary_tag"
                      >
                        <label
                          class="text-xxs fw-bold text-primary"
                          >Primary Tag</label
                        >
                        <div class="mt-2">
                          <span class="badge bg-secondary text-xxs fw-normal">
                            {{ selected_report.primary_tag.name }}
                          </span>
                        </div>
                      </div>

                      <div
                        class="col-md-3 mb-4 border-start-md"
                        v-if="selected_report.tags && selected_report.tags.length"
                      >
                        <label
                          class="text-xxs fw-bold text-muted"
                          >Tags</label
                        >
                        <div class="mt-2 d-flex flex-wrap gap-1">
                          <span
                            v-for="tag in selected_report.tags"
                            :key="tag.id"
                            class="badge bg-secondary text-white text-xxs fw-normal"
                          >
                            {{ tag.name || tag.tag }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mb-4"
                      v-if="selected_report.authors && selected_report.authors.length"
                    >
                      <label
                        class="text-xxs fw-bold text-muted d-block mb-2"
                        >External Authors</label
                      >
                      <div class="d-flex flex-wrap gap-2">
                        <div
                          v-for="author in selected_report.authors"
                          :key="author.id"
                          class="border rounded px-2 py-1 bg-white shadow-sm d-flex align-items-center"
                        >
                          <span class="text-xxs fw-500"
                            >{{ author.author_name }}</span
                          >
                          <a
                            v-if="author.author_link"
                            :href="author.author_link"
                            target="_blank"
                            class="ms-2 text-primary"
                          >
                            <i class="bi bi-box-arrow-up-right text-xxs"></i>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mb-4"
                      v-if="selected_report.report_files && selected_report.report_files.length"
                    >
                      <label
                        class="text-xxs fw-bold text-muted mb-2 d-block"
                        >Attachments</label
                      >
                      <div
                        v-for="(fileObj, index) in selected_report.report_files"
                        :key="index"
                        class="mb-3"
                      >
                        <div
                          class="media-container image-only mb-3 text-center"
                          v-if="fileObj?.file?.url && (
                          fileObj.file.url.includes('.jpg') || fileObj.file.url.includes('.png') || 
                          fileObj.file.url.includes('.jpeg') || fileObj.file.url.includes('.webp'))"
                        >
                          <img
                            :src="fileObj.file.url"
                            alt="Report Image"
                            class="img-fluid rounded-3 border shadow-sm"
                          />
                          <div class="mt-2 text-center">
                            <a
                              :href="fileObj.file.url"
                              download
                              class="btn btn-sm btn-primary text-xs py-1 rounded"
                              >Download Image</a
                            >
                          </div>
                        </div>

                        <div
                          class="media-container video-audio mb-3"
                          v-else-if="fileObj?.file?.url && (fileObj.file.url.includes('.mp3') || fileObj.file.url.includes('.wav'))"
                        >
                          <audio
                            controls
                            class="w-100 rounded-3 p-1 border bg-light"
                          >
                            <source
                              :src="fileObj.file.url"
                              :type="fileObj.file.url.includes('.mp3') ? 'audio/mpeg' : 'audio/wav'"
                            />
                          </audio>
                        </div>

                        <div
                          v-else
                          class="uploaded-file d-flex align-items-center justify-content-between p-2 border rounded bg-white shadow-sm"
                        >
                          <div class="d-flex align-items-center">
                            <img
                              v-if="fileObj?.file?.url"
                              :src="getFileIcon(fileObj.file.url)"
                              class="file-icon small-icon"
                              style="width: 24px"
                            />
                            <span
                              class="file-name text-xxs text-break ms-2 fw-500"
                              >{{ getFileName(fileObj?.file?.url) }}</span
                            >
                            <a :href="fileObj?.file?.url" download class="ms-3"
                              ><i class="bi bi-download fs-6 text-muted"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row text-center mt-3 pt-3 border-top">
                      <div class="col-6">
                        <p class="mb-0 text-xxs text-muted">Likes</p>
                        <h5 class="mb-0 text-xs">
                          {{ selected_report.total_likes }}
                        </h5>
                      </div>
                      <div class="col-6">
                        <p class="mb-0 text-xxs text-muted">Comments</p>
                        <h5 class="mb-0 text-xs">
                          {{ selected_report.total_comments }}
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer d-flex justify-content-end">
                    <div
                      v-if="(String(selected_report.base_profile?.user?.id) === String(user_details.user_id)) || user_details.user_role === 'admin'"
                    >
                      <button
                        type="button"
                        class="btn btn-primary btn-sm text-xxs me-2"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_report_modal"
                        @click="edit_report(selected_report)"
                      >Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary btn-sm text-xxs me-2"
                        @click="delete_report(selected_report.id)"
                      >Delete
                      </button>
                      <button
                        type="button"
                        :class="[
                        'btn',
                        selected_report.is_disabled ? 'btn-primary' : 'btn-secondary',
                        'btn-sm',
                        'text-xxs',
                        'me-2',
                      ]"
                        @click="disable_report_method(selected_report.id, selected_report.is_disabled)"
                      >
                        {{ selected_report.is_disabled ? 'Enable' : 'Disable' }}
                      </button>
                      <!-- <button type="button" class="btn btn-sm btn-secondary text-xxs rounded" data-bs-dismiss="modal">Close</button> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </teleport>

          <teleport to="body">
            <div
              class="modal fade"
              id="edit_report_modal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div
                    class="modal-header bg-primary text-white position-relative"
                  >
                    <h5 class="modal-title text-white" id="exampleModalLabel">
                      Edit your Feed
                    </h5>
                    <button
                      type="button"
                      class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form @submit.prevent="edit_report_data">
                    <div class="modal-body">
                      <div
                        class="mt-2 m-2 d-flex align-items-center flex-wrap gap-2"
                      >
                        <span
                          class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1"
                          @click="openEditCategoryModal"
                          >Tag a category
                        </span>
                        <div class="d-flex flex-wrap gap-1">
                          <span
                            v-for="tag in allSelectedTags"
                            :key="tag.id"
                            class="btn-sm d-flex align-items-center bg-light border px-3 py-1"
                          >
                            {{ tag.name }}
                          </span>
                        </div>

                        <span
                          class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1"
                          @click="open_edit_author_modal"
                          >Edit Author</span
                        >
                        <div
                          v-if="report_edit && report_edit.authors && report_edit.authors.length"
                          class="d-flex flex-wrap gap-2 align-items-center"
                        >
                          <span
                            v-for="(author, index) in report_edit.authors"
                            :key="index"
                            class="btn-sm d-flex align-items-center bg-light border"
                          >
                            {{ author.author_name }}
                            <a
                              v-if="author.link"
                              :href="author.link"
                              target="_blank"
                              class="text-white ms-1 text-decoration-underline"
                              @click.stop
                            >
                              🔗</a
                            >
                            <button
                              type="button"
                              class="btn-close btn-close-dark btn-sm ms-1"
                              aria-label="Remove"
                              @click="remove_author_method(index)"
                            ></button>
                          </span>
                        </div>
                      </div>
                      <!-- Select Topic -->
                      <div
                        v-if="topics.length > 0"
                        class="m-2 d-flex align-items-center flex-wrap gap-2"
                      >
                        <label class="form-label text-xxs fw-500"
                          >Segment (Topic)</label
                        >
                        <select
                          class="btn btn-sm btn-outline-secondary text-xxs px-3 py-1"
                          v-model="selected_topic"
                          id="topic"
                        >
                          <option value="" selected hidden>
                            Tag a segment
                          </option>
                          <option
                            v-for="topic in topics"
                            :value="topic.id"
                            :key="topic.id"
                          >
                            {{ topic.name }}
                          </option>
                        </select>
                      </div>
                      <div class="d-flex align-items-center mb-3">
                        <label
                          for="toggle-comments"
                          class="form-label mb-0 text-xs fw-500"
                          >Allow comments:</label
                        >
                        <div class="form-check form-switch comment-switch">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="toggle-comments"
                            v-model="comments_off"
                          />
                        </div>
                        <label
                          class="form-check-label text-xxs"
                          for="toggle-comments"
                          >{{ comments_off ? 'Yes' : 'No' }}</label
                        >
                      </div>

                      <QuillEditor
                        theme="snow"
                        v-model="report_description"
                        ref="quillReportRef"
                        class="quill-editor"
                        toolbar="full"
                      />
                      <div
                        v-if="report_edit.linkPreview"
                        class="link-preview rounded mt-2 p-2 position-relative border"
                      >
                        <a
                          :href="report_edit.report_link"
                          target="_blank"
                          class="stretched-link text-decoration-none"
                        >
                          <img
                            v-if="report_edit.linkPreview.image"
                            :src="report_edit.linkPreview.image"
                            class="img-fluid rounded"
                          />
                          <div class="fw-bold mt-2">
                            {{ report_edit.linkPreview.title }}
                          </div>
                          <div
                            v-if="!report_edit.linkPreview.image"
                            class="text-muted small"
                          >
                            {{ report_edit.linkPreview.description }}
                          </div>
                        </a>
                      </div>
                      <div
                        class="d-flex mt-2 mx-1 justify-content-between align-items-start flex-wrap"
                      >
                        <div
                          class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center"
                        >
                          <label
                            for="editReportFileInput"
                            class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center"
                          >
                            <i class="bx bx-image-add file-upload-icon"></i> Add
                            Feed content
                          </label>
                          <input
                            type="file"
                            ref="editReportFileInput"
                            id="editReportFileInput"
                            class="file-input d-none"
                            @change="handle_file_upload"
                          />

                          <!-- Truncated File Name -->
                          <div
                            v-if="editFileName"
                            class="file-name text-xxs text-secondary fst-italic mt-1"
                            :title="editFileName"
                          >
                            <span class="fw-500">File name:</span> {{
                            editFileName }}
                          </div>

                          <!-- Error Message -->
                          <div
                            v-if="fileError"
                            class="text-xxs text-danger fst-italic mt-1"
                          >
                            {{ fileError }}
                          </div>
                        </div>

                        <!-- Audio Upload -->
                        <div
                          class="file-upload my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center"
                        >
                          <label
                            for="audioInput"
                            class="text-xxs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center"
                          >
                            <i class="bx bx-music"></i> Upload Audio
                          </label>
                          <input
                            type="file"
                            accept="audio/*"
                            id="audioInput"
                            class="file-input d-none"
                            @change="handleAudioUpload"
                          />
                          <div
                            v-if="audioError"
                            class="text-xxs text-danger fst-italic mt-1"
                          >
                            {{ audioError }}
                          </div>
                        </div>

                        <!-- Audio Recorder -->
                        <div
                          class="d-flex flex-column align-items-center my-2 flex-grow-1"
                        >
                          <div class="d-flex flex-row align-items-center mb-3">
                            <button
                              type="button"
                              class="btn btn-light text-xxs text-secondary rounded-5 mx-2 d-flex align-items-center justify-content-center"
                              @click="startRecording"
                              v-if="!isRecording"
                            >
                              <i class="bx bx-microphone"></i> Record
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger text-xxs rounded-5 mx-2 d-flex align-items-center justify-content-center"
                              @click="stopRecording"
                              v-if="isRecording"
                            >
                              <i class="bx bx-stop"></i> Stop
                            </button>
                          </div>
                          <div
                            v-if="audio_file_name"
                            class="text-xxs text-secondary fw-500 mb-3 audio-file"
                          >
                            <i class="bx bx-music"></i> Recorded: {{
                            audio_file_name }}
                          </div>
                        </div>
                      </div>

                      <div
                        class="d-flex flex-column"
                        v-if="edit_documents.report_files && edit_documents.report_files.length"
                      >
                        <div class="row g-3">
                          <div
                            v-for="(fileObj, index) in edit_documents.report_files"
                            :key="index"
                            class="position-relative mb-3"
                          >
                            <button
                              type="button"
                              class="btn-close btn-close-dark btn-sm position-absolute top-0 end-0 m-2"
                              aria-label="Remove"
                              @click="markFileForRemoval(fileObj.id, index)"
                            ></button>
                            <!-- Image -->
                            <img
                              v-if="fileObj.file.url.includes('.jpg') || fileObj.file.url.includes('.png') || fileObj.file.url.includes('.jpeg')"
                              :src="fileObj.file.url"
                              alt="Feed Image"
                              class="img-fluid rounded-5 w-100 h-100"
                              :class="{ 'zoomed-in': isZoomed }"
                              ref="image"
                            />

                            <!-- Audio -->
                            <audio
                              v-else-if="fileObj.file.url.includes('.mp3') || fileObj.file.url.includes('.wav')"
                              controls
                              class="w-100 rounded-5"
                            >
                              <source
                                :src="fileObj.file.url"
                                type="audio/mp3"
                              />
                              Your browser does not support the audio element.
                            </audio>

                            <!-- Video -->
                            <video
                              v-else-if="/\.(mp4|webm|ogg|ogv|mov|m4v|avi|mkv|wmv|flv|3gp|3g2)(?:$|[?#])/i.test(fileObj.file.url)"
                              controls
                              class="img-fluid rounded-5 w-100"
                            >
                              <source
                                :src="fileObj.file.url"
                              />
                              Your browser does not support the video tag.
                            </video>

                            <!-- PDF -->
                            <iframe
                              v-else-if="fileObj.file.url.includes('.pdf')"
                              :src="fileObj.file.url"
                              class="img-fluid rounded media_preview"
                              frameborder="0"
                            >
                            </iframe>

                            <!-- Word Document -->
                            <iframe
                              v-else-if="fileObj.file.url.includes('.docx') || fileObj.file.url.includes('.doc')"
                              :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.url)"
                              frameborder="0"
                              width="100%"
                              height="500px"
                            >
                            </iframe>

                            <!-- Excel Document -->
                            <iframe
                              v-else-if="fileObj.file.url.includes('.xls') ||
                                      fileObj.file.url.includes('.xlsx') ||
                                      fileObj.file.url.includes('.xlsm') ||
                                      fileObj.file.url.includes('.xlsb')"
                              :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.url)"
                              frameborder="0"
                              width="100%"
                              height="500px"
                            >
                            </iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="submit"
                        class="btn btn-primary text-xxs rounded"
                      >
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </teleport>

          <teleport to="body">
            <div
              class="modal fade"
              id="author_modal_edit"
              tabindex="-1"
              aria-labelledby="author_modal_edit_label"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 rounded-5 shadow-sm">
                  <div class="modal-header">
                    <h6 class="modal-title" id="author_modal_edit_label">
                      Edit Authors
                    </h6>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <!-- Inputs for editing/adding authors -->
                    <input
                      type="text"
                      class="form-control form-control-sm mb-2 rounded"
                      v-model="edit_author_input"
                      placeholder="Enter author name"
                    />

                    <input
                      type="url"
                      class="form-control form-control-sm mb-2 rounded"
                      v-model="edit_author_link"
                      placeholder="Enter author link (optional)"
                    />

                    <button
                      type="button"
                      class="btn btn-primary btn-sm mb-2 rounded"
                      @click="add_author_method"
                    >
                      Add Author
                    </button>

                    <!-- List of existing authors -->
                    <div v-if="edit_authors.length" class="mt-2">
                      <div class="d-flex flex-wrap justify-content-start gap-1">
                        <span
                          v-for="(author, index) in edit_authors"
                          :key="index"
                          class="btn-sm d-flex align-items-center bg-light border px-3 py-1"
                        >
                          {{ author.author_name }}
                          <button
                            type="button"
                            class="btn-close btn-close-dark btn-sm ms-1"
                            aria-label="Remove"
                            @click="remove_author_method(index)"
                          ></button>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm rounded"
                      @click="save_edit_author"
                      data-bs-dismiss="modal"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_report_modal"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </teleport>

          <teleport to="body">
            <div
              class="modal fade"
              id="category_modal_edit"
              tabindex="-1"
              aria-labelledby="category_modal_label"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 rounded-5 shadow-sm">
                  <div class="modal-header">
                    <h6 class="modal-title" id="category_modal_label">
                      Select Tags for Category
                    </h6>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  <div class="modal-body">
                    <!-- PRIMARY TAG -->
                    <div class="mb-4">
                      <label class="form-label fw-bold mb-1">Primary Tag</label>

                      <div
                        v-for="(category, index) in categories"
                        :key="'primary-edit-'+category.id"
                        v-show="index < 2 || showAllPrimary"
                        class="col-md-12"
                      >
                        <label class="form-label fw-bold mb-1 text-xxs"
                          >{{ category.name }}</label
                        >

                        <multiselect
                          :model-value="primary_tags.get(category.id)"
                          @update:modelValue="tag => selectPrimaryTag(category.id, tag)"
                          :options="category.tags"
                          :multiple="false"
                          placeholder="Select primary tag"
                          track-by="id"
                          label="name"
                          class="text-xs fw-500 mb-3"
                        >
                          <template #option="{ option }">
                            <span class="fw-500 text-xxs"
                              >{{ option.name }}</span
                            >
                          </template>
                          <template #selection="{ values }">
                            <span v-if="values" class="badge bg-success"
                              >{{ values.name }}</span
                            >
                          </template>
                        </multiselect>
                      </div>

                      <div v-if="categories.length > 2" class="mt-2">
                        <button
                          type="button"
                          class="btn btn-link btn-sm text-decoration-none"
                          @click="showAllPrimary = !showAllPrimary"
                        >
                          {{ showAllPrimary ? 'Show Less' : 'Show More' }}
                        </button>
                      </div>
                    </div>

                    <!-- SECONDARY TAGS -->
                    <div class="mb-4">
                      <label class="form-label fw-bold mb-1"
                        >Secondary Tags</label
                      >

                      <div
                        v-for="(category, index) in categories"
                        :key="'secondary-edit-'+category.id"
                        v-show="index < 2 || showAllSecondary"
                        class="col-md-12"
                      >
                        <label class="form-label fw-bold mb-1 text-xxs"
                          >{{ category.name }}</label
                        >

                        <multiselect
                          :model-value="selected_tags.get(category.id)"
                          @update:modelValue="updateTagSelection(category.id, $event)"
                          :options="category.tags"
                          :multiple="true"
                          :preserve-search="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          placeholder="Select tags"
                          class="text-xs fw-500 mb-3"
                          track-by="id"
                          label="name"
                        >
                          <template #option="{ option }">
                            <span class="fw-500 text-xxs"
                              >{{ option.name }}</span
                            >
                          </template>
                          <template #selection="{ values }">
                            <span
                              v-for="(tag, index) in values"
                              :key="index"
                              class="badge bg-primary me-1"
                            >
                              {{ tag.name }}
                            </span>
                          </template>
                        </multiselect>
                      </div>

                      <div v-if="categories.length > 2" class="mt-2">
                        <button
                          type="button"
                          class="btn btn-link btn-sm text-decoration-none"
                          @click="showAllSecondary = !showAllSecondary"
                        >
                          {{ showAllSecondary ? 'Show Less' : 'Show More' }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="text-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-sm text-xxs rounded-3 shadow-sm m-3"
                      @click="submit_tags"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_report_modal"
                      data-bs-dismiss="modal"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </teleport>
        </div>
      </div>
    </div>
  </div>
</div>
